(() => {
  if (window.__coluluCouponCopyBound) return;
  window.__coluluCouponCopyBound = true;

  const copyText = async (code) => {
    try {
      await navigator.clipboard.writeText(code);
      return true;
    } catch (error) {
      const input = document.createElement('textarea');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.append(input);
      input.select();
      const copied = document.execCommand('copy');
      input.remove();
      return copied;
    }
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-coupon-copy], .coupon-copy');
    if (!button) return;

    const coupon = button.closest('[data-coupon-code]');
    const code = coupon?.dataset.couponCode?.trim() || button.dataset.couponCode?.trim();
    const status = coupon?.querySelector('[data-coupon-status]');
    if (!code) {
      if (status) status.textContent = 'クーポンコードが設定されていません。';
      return;
    }

    const copied = await copyText(code);
    if (status) status.textContent = copied
      ? `クーポンコード ${code} をコピーしました。`
      : `クーポンコードは ${code} です。`;
  });
})();
